import { Spin, SpinProps } from 'antd';
import { clsx } from 'clsx';
import { FC } from 'react';

import s from './AntSpin.module.less';

type ClassNamesObject = Exclude<SpinProps['classNames'], ((...args: never[]) => unknown) | undefined>;

const withOwnRoot = (classNames: ClassNamesObject | undefined) => ({
  ...classNames,
  root: clsx(s.antSpin, classNames?.root),
});

export const AntSpin: FC<SpinProps> = (props) => {
  const { classNames, ...rest } = props;

  // Merged rather than set, so a caller's own `classNames` keeps the dimming class.
  const mergedClassNames: SpinProps['classNames'] =
    typeof classNames === 'function' ? (info) => withOwnRoot(classNames(info)) : withOwnRoot(classNames);

  return <Spin {...rest} classNames={mergedClassNames} />;
};

AntSpin.displayName = 'AntSpin';
